<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
    <section class="pt-24 pb-12 sm:pt-24 sm:pb-12">
        <UContainer>
            <div class="flex flex-col gap-4.5 items-center lg:max-w-[800px] mx-auto">
                <h1 class="uppercase text-secondary text-[30px] leading-[38px] sm:text-[46px] sm:leading-[48px]">{{ t('shop.title') }}</h1>
                <p class="text-center text-secondary">{{ t('shop.description') }}</p>
            </div>
        </UContainer>
    </section>
</template>

<style scoped>

</style>
